export default "__VITE_ASSET__DtbXm3AO__"